var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modules-settings-tenancy-users" }, [
    _c(
      "div",
      { staticClass: "title-container" },
      [
        _c("div", { staticClass: "title-container-left" }, [
          _c(
            "a",
            {
              staticClass: "all-tenants",
              on: {
                click: function ($event) {
                  return _vm.navToPage("all-tenants")
                },
              },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("view")) +
                  " " +
                  _vm._s(_vm.$t("settings.user.tenant.all"))
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { calss: "total-wth-refresh" } }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("total")) +
                  ": " +
                  _vm._s(_vm.orderedUsers.length) +
                  " / " +
                  _vm._s(_vm.recordCounts)
              ),
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-refresh dark flat icon_refresh",
              attrs: { id: "tenancy_user_refresh" },
              on: {
                click: function ($event) {
                  return _vm.init()
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("HKLButton", {
          staticClass: "reset-btn",
          attrs: { color: "darkblue", action: "resetFilter" },
          on: { click: _vm.resetFilter },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tender-table" }, [
      _c("table", [
        _c(
          "thead",
          _vm._l(_vm.itemHeaders, function (header, index) {
            return _c(
              "th",
              {
                key: index,
                class: header.class,
                on: {
                  click: function ($event) {
                    return _vm.sortBy(header.code)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t(header.name)) +
                    " " +
                    _vm._s(
                      _vm.tenancySorting.orderbyAttr === header.code
                        ? _vm.tenancySorting.reverse
                          ? "▼"
                          : "▲"
                        : null
                    ) +
                    "\n        "
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("tr", [
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tenancyFilter.userAccount,
                      expression: "tenancyFilter.userAccount",
                    },
                  ],
                  staticClass: "setting-users-filter-search",
                  attrs: {
                    type: "text",
                    id: "settings-users-tenancy-user-search",
                  },
                  domProps: { value: _vm.tenancyFilter.userAccount },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.tenancyFilter,
                        "userAccount",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "settings-filter align-center" },
                [
                  _c("HKLSelect", {
                    staticClass: "align-center",
                    attrs: {
                      value: _vm.tenancyFilter.isMasterAccount,
                      "settings-filter-row": "",
                      options: _vm.ynHklOptions,
                      showSearch: false,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.tenancyFilter.isMasterAccount = val
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "2" } }),
            ]),
            _vm._v(" "),
            _vm._l(_vm.orderedUsers, function (item, index) {
              return _c("tr", { key: index }, [
                _c("td", [
                  _c("div", { staticClass: "align-left" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.navToDetail(item.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.userAccount))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm._f("customYNLabel")(
                          item.isMasterAccount
                            ? _vm.ynOptions.YES
                            : _vm.ynOptions.NO
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [_c("div", [_vm._v(_vm._s(item.lastLoginOn))])]),
                _vm._v(" "),
                _c("td", [_c("div", [_vm._v(_vm._s(item.lastInvitedAt))])]),
              ])
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }